export default function getErrorMessage(vm, errorCode, fallback, data) {
  let messageKey
  if (vm.$te(`ApiErrorCode.${errorCode}`)) {
    messageKey = `ApiErrorCode.${errorCode}`
  } else {
    messageKey = fallback || 'Global.unknownError'
  }
  return vm.$t(messageKey, data)
}
